import React from 'react';
import { Gap } from 'lib/components/styles/layout';
import { LpDesignCategories } from '../../constants';
import { FormikDropdownField } from 'lib/components/formik/FormikDropdown';
import { useTheme } from 'styled-components/macro';
import { FormikInputFastField } from 'lib/components/formik/FormikInputFastField';

interface ITitleAndCategoryFormProps {
  isCovideoSuperAdmin?: boolean;
}

const TitleAndCategoryForm = ({
  isCovideoSuperAdmin,
}: ITitleAndCategoryFormProps) => {
  const theme = useTheme();

  return (
    <Gap gap='20px' flexDirection='row' alignItems='baseline' width='100%'>
      <Gap gap='3px' width={isCovideoSuperAdmin ? '386px' : '100%'}>
        <FormikInputFastField
          name='title'
          label='Template Title'
          isRequired
          placeholder='Title'
          extendStyles={{
            asteriskStyles: {
              color: theme.colors.neutral[80],
            },
            labelStyles: {
              color: theme.colors.neutral[80],
              fontWeight: 600,
            },
            inputWrapper: {
              padding: '5px 0 0 0',
              width: isCovideoSuperAdmin ? '380px' : '100%',
            },
          }}
        />
      </Gap>
      {isCovideoSuperAdmin && (
        <Gap gap='8px' width='386px'>
          <FormikDropdownField
            name='category'
            options={LpDesignCategories}
            label='Template Type'
            isRequired
            disabled={false}
            extendStyles={{
              asteriskStyles: {
                color: theme.colors.neutral[80],
              },
              labelStyles: {
                fontWeight: 600,
                color: theme.colors.neutral[80],
                marginBottom: '4px',
              },
            }}
            menuPortalTarget={null}
          />
        </Gap>
      )}
    </Gap>
  );
};

export default TitleAndCategoryForm;
